import gql from 'graphql-tag'

const GET_MERCHANT_INTEGRATIONS = gql`
  query getMerchantPartners($merchantId: uuid!) {
    partners_merchants(where: { merchant_id: { _eq: $merchantId } }) {
      partner {
        name
      }
    }
  }
`

const CREATE_INTEGRATION = gql`
  mutation CreateIntegration($partnerName: PartnerName!) {
    createIntegration(partnerName: $partnerName)
  }
`
const REMOVE_INTEGRATION = gql`
  mutation RemoveIntegration($partnerName: PartnerName!) {
    removeIntegration(partnerName: $partnerName)
  }
`

const GET_AUTH_URL = gql`
  query GetAuthURL($partnerName: PartnerName!) {
    getOauthAuthorizationUrl(partnerName: $partnerName)
  }
`

export {
  GET_MERCHANT_INTEGRATIONS,
  CREATE_INTEGRATION,
  REMOVE_INTEGRATION,
  GET_AUTH_URL
}
